// src/pages/ModuleDetails.jsx
import React from "react";
import { useParams } from "react-router-dom";

const moduleContent = {
  "cyber-security": {
    "1": {
      title: "Introduction & Orientation",
      meetLink: "https://meet.google.com/example-link",
      content:
        "Welcome to the Cyber Security Internship! Learn about the structure, expectations, and how to navigate through the internship.",
      attachments: [{ name: "Internship Overview PDF", url: "/downloads/cyber-orientation.pdf" }],
      quizLink: "https://forms.gle/sample-cyber-quiz",
    },
    "2": {
      title: "Network Security Basics",
      content:
        "Core network security concepts like firewalls, proxies, and encryption basics.",
      attachments: [{ name: "Network Fundamentals PPT", url: "/downloads/network-basics.pptx" }],
      quizLink: "https://forms.gle/network-quiz",
    },
    "3": {
      title: "Web Application Security",
      content:
        "Common web vulnerabilities such as SQL Injection, XSS, CSRF, and prevention techniques.",
      attachments: [{ name: "OWASP Top 10 Guide", url: "/downloads/owasp-top10.pdf" }],
      quizLink: "https://forms.gle/webapp-security-check",
    },
    "4": {
      title: "Ethical Hacking & Tools",
      meetLink: "https://meet.google.com/hack-tools-session",
      content:
        "Penetration testing methods and tools like Nmap, Wireshark, Metasploit.",
      attachments: [
        { name: "Ethical Hacking Tools Cheat Sheet", url: "/downloads/hacking-tools.pdf" },
        { name: "Wireshark Lab", url: "/downloads/wireshark-lab.zip" },
      ],
      quizLink: "https://forms.gle/ethical-hack-check",
    },
    "5": {
      title: "Final Assessment & Certification",
      content:
        "Submit final assessment and unlock your certificate.",
      attachments: [],
      quizLink: "https://forms.gle/final-assessment-form",
    },
  },
"python-programming": {
  "1": {
    "title": "Day 1: Introduction to Python – What is Python, why use it, installing Python, setting up IDE (PyCharm, VSCode, Jupyter Notebook)",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn the basics of Python, why it's popular, and how to install and set up development environments.",
    "attachments": [{ "name": "Python Setup Guide PDF", "url": "https://drive.google.com/file/d/1bPW3jni1dTLGJsdBzJr7sDWorDk3leSx/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "2": {
    "title": "Day 2: Writing your first Python program – 'Hello World', understanding syntax, comments, and indentation rules",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Write your first program and understand Python's syntax, commenting, and indentation.",
    "attachments": [{ "name": "Hello World Examples", "url": "https://drive.google.com/file/d/1SCbex57XDoWLkkJWCRv1rxHM4kf2UGFb/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "3": {
    "title": "Day 3: Variables and Data Types – integers, floats, strings, booleans; type conversion and type checking",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Understand and use Python's basic data types, including conversion and checking techniques.",
    "attachments": [{ "name": "Data Types Notes", "url": "https://drive.google.com/file/d/1jRZnBprdUEOBOtQyI7cm8pBTYIFR_1ij/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "4": {
    "title": "Day 4: Taking user input, printing output, and string formatting techniques",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn input and output operations, along with string formatting methods.",
    "attachments": [{ "name": "IO and Formatting Examples", "url": "https://drive.google.com/file/d/1S3U9HYsSC92eALeXbvO6ZYplbH_0Ikmt/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "5": {
    "title": "Day 5: Conditional Statements – if, if-else, elif, nested if statements with examples",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Use conditional statements to control the flow of your Python programs.",
    "attachments": [{ "name": "Conditionals Guide", "url": "https://drive.google.com/file/d/1Mm1gk7UiTJQ0rGZmYXSqPg0BmI5oU-pZ/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "6": {
    "title": "Day 6: Loops – for loop, while loop, nested loops, and the range() function",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Master different looping techniques in Python.",
    "attachments": [{ "name": "Loops Practice Sheet", "url": "https://drive.google.com/file/d/1H5E12HfyqU_FJKV3HsEXvvoqmtHy1UBh/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "7": {
    "title": "Day 7: Loop control statements – break, continue, pass, and simple exercises",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn how to control loop execution flow.",
    "attachments": [{ "name": "Loop Control Exercises", "url": "https://drive.google.com/file/d/12CkGWuqzGoEc-rSxGX6Rib38cWYQ7Pm0/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "8": {
    "title": "Day 8: Lists – creating, indexing, slicing, adding, removing, updating elements",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Work with Python lists and their operations.",
    "attachments": [{ "name": "Lists Examples", "url": "https://drive.google.com/file/d/1Dy8DXor9eRHJVWkCsdkrpp0pKYzxFLYl/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "9": {
    "title": "Day 9: Tuples – creating, accessing elements, immutability, tuple methods",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Understand and work with Python tuples.",
    "attachments": [{ "name": "Tuples Notes", "url": "https://drive.google.com/file/d/1Vz2ph0TkekmpYTZ2iTgNKkjLRHYhL3Da/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "10": {
    "title": "Day 10: Dictionaries – key-value pairs, adding, updating, deleting, dictionary methods",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn dictionary operations in Python.",
    "attachments": [{ "name": "Dictionaries Guide", "url": "https://drive.google.com/file/d/1e66Y6uJ4sXNgybRbmlbhfdNawQyMD2Yo/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "11": {
    "title": "Day 11: Sets – creating, adding/removing elements, set operations (union, intersection)",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Explore sets and their operations in Python.",
    "attachments": [{ "name": "Sets Examples", "url": "https://drive.google.com/file/d/1z_YEBDUzuND9d1OjB_qsjxHv0Ubnu7Mo/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "12": {
    "title": "Day 12: Functions – defining, calling, parameters, return values, default arguments",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Create reusable functions in Python.",
    "attachments": [{ "name": "Functions Workbook", "url": "https://drive.google.com/file/d/176iYUiE-JPOf4sjqKT4edslmfxLuAVWS/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "13": {
    "title": "Day 13: Lambda functions and map(), filter(), reduce() usage",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Use anonymous functions and functional programming tools.",
    "attachments": [{ "name": "Lambda & Map-Filter-Reduce Notes", "url": "https://drive.google.com/file/d/1Jxt71wUwrHGYFjHRrm7VFaN5fax4VhCn/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "14": {
    "title": "Day 14: Practice session – problems on lists, dictionaries, functions",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Practice exercises combining previous topics.",
    "attachments": [{ "name": "Practice Problems", "url": "https://drive.google.com/file/d/13LYjh19PuvVd0YfmiT7Lik-kNgnFmM3i/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "15": {
    "title": "Day 15: File Handling – reading and writing text files, working with CSV files",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn to handle files and process CSV data.",
    "attachments": [{ "name": "File Handling Guide", "url": "https://drive.google.com/file/d/1VYCz061KWemEbSgY423aoe6I9-eyGfYa/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "16": {
    "title": "Day 16: Error Handling – try-except, finally, raising exceptions, custom exceptions",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Handle runtime errors gracefully in Python.",
    "attachments": [{ "name": "Error Handling Notes", "url": "https://drive.google.com/file/d/1xg0lfCNIG611VAUOtz-DNnNQkmjwq-3O/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "17": {
    "title": "Day 17: Introduction to Object-Oriented Programming (OOP) – classes and objects",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Learn the basics of OOP in Python.",
    "attachments": [{ "name": "OOP Introduction", "url": "https://drive.google.com/file/d/13EcEksyhiHvytoGSImZeQeyzYULNvWlU/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "18": {
    "title": "Day 18: Attributes and methods – instance variables, class variables, instance methods",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Understand Python's object attributes and methods.",
    "attachments": [{ "name": "OOP Attributes & Methods", "url": "https://drive.google.com/file/d/1AQAqgnOuqzi9iosN9z_t05SVqT-SlMgh/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "19": {
    "title": "Day 19: Constructors (__init__ method) and object lifecycle",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Work with constructors and understand object lifecycles.",
    "attachments": [{ "name": "Constructors Notes", "url": "https://drive.google.com/file/d/1lc4d0M4tVUSjExEn8IqFM0sQtJZw91YT/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "20": {
    "title": "Day 20: Inheritance – single, multiple, multilevel, method overriding",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Master Python inheritance types and overriding methods.",
    "attachments": [{ "name": "Inheritance Guide", "url": "https://drive.google.com/file/d/1pV0pOI8bgqV66edIngiClbhQy2pEsbgd/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
  "21": {
    "title": "Day 21: Practice session – OOP-based exercises",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Practice OOP concepts through exercises.",
    "attachments": [{ "name": "OOP Exercises", "url": "https://drive.google.com/file/d/1CS9PVkTv3XSoZ4QAFHV0Frwvn9Htpyjm/view?usp=sharing" }],
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  },
    "22": {
    "title": "Day 22: Project Introduction",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Understand the project requirements and plan development.",
    "attachments": [{ "name": "Project Plan PDF", "url": "https://drive.google.com/file/d/1JBuoLz3wYY9pcby2g9ALlwVzgGmkWjKU/view?usp=sharing" }]
  },
  "23": {
    "title": "Day 23: Implementing student data input and grade calculation logic",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Implement logic for managing student grades.",
    "attachments": [{ "name": "Grade Calculation Notes", "url": "https://drive.google.com/file/d/1JBuoLz3wYY9pcby2g9ALlwVzgGmkWjKU/view?usp=sharing" }]
  },
  "24": {
    "title": "Day 24: Storing data in a file and retrieving it on program start",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Save and retrieve data persistently.",
    "attachments": [{ "name": "Data Storage Examples", "url": "https://drive.google.com/file/d/1JBuoLz3wYY9pcby2g9ALlwVzgGmkWjKU/view?usp=sharing" }]
  },
  "25": {
    "title": "Day 25: Adding search functionality for student results by roll number",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Implement search features in the project.",
    "attachments": [{ "name": "Search Functionality Guide", "url": "https://drive.google.com/file/d/1JBuoLz3wYY9pcby2g9ALlwVzgGmkWjKU/view?usp=sharing" }]
  },
  "26": {
    "title": "Day 26: Testing and debugging the project",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Test and debug your project for reliability.",
    "attachments": [{ "name": "Testing Checklist", "url": "https://drive.google.com/file/d/1JBuoLz3wYY9pcby2g9ALlwVzgGmkWjKU/view?usp=sharing" }]
  },
  "27": {
    "title": "Day 27: Final project completion and preparing submission files",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Complete and prepare your project for submission.",
    "attachments": [{ "name": "Submission Guide", "url": "/downloads/python-submission.pdf" }]
  },
  "28": {
    "title": "Day 28-42: Submission review and certificate distribution",
    "meetLink": "https://meet.google.com/yfd-gszz-gxv",
    "content": "Review submissions and receive your certificate.",
    "quizLink": "https://forms.gle/XRmvGt98Ldrw4mNn8"
  }
},

  "ai-ml": {
    "1": {
    "title": "Python & Data Analysis",
    "content": "Learn Python basics, NumPy, Pandas, Matplotlib, Seaborn, and perform Exploratory Data Analysis (EDA).",
    "attachments": [],
    "quizLink": "https://forms.gle/ai-python-eda"
  }
  },

  "web-dev": {
    "1": {
      title: "HTML/CSS/JS Basics",
      content: "Basics of web development with HTML, CSS, and JavaScript.",
      attachments: [],
      quizLink: "https://forms.gle/web-basics-quiz",
    },
    "2": {
      title: "React + Tailwind Setup",
      meetLink: "https://meet.google.com/react-tailwind",
      content: "Setup modern web app with React and Tailwind CSS.",
      attachments: [{ name: "React Starter Template", url: "/downloads/react-tailwind.zip" }],
      quizLink: "",
    },
    "3": {
      title: "APIs & Routing",
      content: "Learn how to connect to APIs and implement routing using React Router.",
      attachments: [],
      quizLink: "https://forms.gle/web-api-routing",
    },
    "4": {
      title: "Mini Project",
      content: "Build a portfolio or a blog website using concepts learned.",
      attachments: [],
      quizLink: "",
    },
    "5": {
      title: "Final Review",
      content: "Submit project and complete final quiz.",
      attachments: [],
      quizLink: "https://forms.gle/web-final",
    },
  },

  "blockchain": {
    "1": {
      title: "What is Blockchain?",
      content: "Introduction to decentralized technologies and blockchain fundamentals.",
      attachments: [{ name: "Blockchain Basics", url: "/downloads/blockchain-intro.pdf" }],
      quizLink: "https://forms.gle/blockchain-intro-quiz",
    },
    "2": {
      title: "Smart Contracts",
      content: "Understand and write smart contracts using Solidity.",
      attachments: [],
      quizLink: "",
    },
    "3": {
      title: "Metamask & Remix",
      meetLink: "https://meet.google.com/blockchain-tools",
      content: "Hands-on session for deploying contracts via Remix IDE and Metamask.",
      attachments: [{ name: "Remix Tutorial", url: "/downloads/remix-tutorial.pdf" }],
      quizLink: "",
    },
    "4": {
      title: "Mini DApp Build",
      content: "Build and test a simple decentralized app (DApp).",
      attachments: [{ name: "Mini DApp Starter", url: "/downloads/dapp-starter.zip" }],
      quizLink: "",
    },
    "5": {
      title: "Wrap-Up & Quiz",
      content: "Complete blockchain internship quiz and receive certificate.",
      attachments: [],
      quizLink: "https://forms.gle/blockchain-final",
    },
  },
};

const ModuleDetails = () => {
  const { id, moduleId } = useParams();
  const data = moduleContent[id]?.[moduleId];

  if (!data) {
    return (
      <div className="min-h-screen bg-[#0f172a] text-white flex items-center justify-center">
        <h2>Module not found.</h2>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-200 text-gray-900 px-6 py-20 max-w-3xl mx-auto">
  <h2 className="text-3xl font-bold text-indigo-600 mb-4">{data.title}</h2>

  {/* Google Meet */}
  {data.meetLink && (
    <div className="bg-indigo-100 p-4 rounded-lg shadow-md mb-6">
      <h3 className="text-lg font-semibold mb-2 text-indigo-700">🔴 Live Session</h3>
      <a
        href={data.meetLink}
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-600 underline hover:text-indigo-800"
      >
        Join Google Meet
      </a>
    </div>
  )}

  {/* Text Content */}
  <div className="prose max-w-none mb-6">
    <p>{data.content}</p>
  </div>

  {/* Attachments */}
  {data.attachments && data.attachments.length > 0 && (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">📎 Downloads</h3>
      <ul className="list-disc ml-6 text-indigo-600">
        {data.attachments.map((file, i) => (
          <li key={i}>
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-indigo-800"
            >
              {file.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )}

  {/* Quiz */}
  {data.quizLink && (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">🧠 Quiz</h3>
      <p className="text-gray-700 mb-2">
        Complete this quiz to mark the module as complete.
      </p>
      <a
        href={data.quizLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-indigo-600 px-4 py-2 rounded text-white hover:bg-indigo-700 transition"
      >
        Take Quiz (Google Form)
      </a>
    </div>
  )}

  {/* Completion Button */}
  <button
    onClick={() => {
      localStorage.setItem(`module-${id}-${moduleId}-done`, "true");
      alert("✅ Module marked as complete!");
    }}
    className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
  >
    ✅ Mark as Complete
  </button>
</div>

  );
};

export default ModuleDetails;
